"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwapButton = exports.TokenIcon = exports.SwapTokenForm = exports.ArrowButton = exports.SwapHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var anchor_1 = require("@project-serum/anchor");
var serum_1 = require("@project-serum/serum");
var spl_token_1 = require("@solana/spl-token");
var web3_js_1 = require("@solana/web3.js");
var react_1 = require("react");
var Dex_1 = require("../context/Dex");
var Swap_1 = require("../context/Swap");
var Token_1 = require("../context/Token");
var TokenList_1 = require("../context/TokenList");
var pubkeys_1 = require("../utils/pubkeys");
var tokens_1 = require("../utils/tokens");
var Info_1 = require("./Info");
var TokenDialog_1 = __importDefault(require("./TokenDialog"));
var useStyles = (0, core_1.makeStyles)(function (theme) { return ({
    card: {
        width: theme.spacing(50),
        borderRadius: theme.spacing(2),
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.075)",
        padding: theme.spacing(2),
    },
    tab: {
        width: "50%",
    },
    settingsButton: {
        padding: 0,
    },
    swapButton: {
        width: "100%",
        borderRadius: theme.spacing(1),
        fontSize: 16,
        fontWeight: 700,
        padding: theme.spacing(1.5),
        "&:disabled": {
            cursor: "not-allowed",
            pointerEvents: "all !important",
        },
    },
    swapToFromButton: {
        display: "block",
        margin: "0px auto 0px auto",
        cursor: "pointer",
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.spacing(1),
        boxShadow: "0px 0px 2px 1px rgba(33,150,243,0.1)",
        fontSize: theme.spacing(4),
    },
    amountInput: {
        fontSize: 22,
        fontWeight: 600,
    },
    input: {
        textAlign: "right",
    },
    swapTokenFormContainer: {
        borderRadius: theme.spacing(2),
        boxShadow: "0px 0px 15px 2px rgba(33,150,243,0.1)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        padding: theme.spacing(1),
    },
    swapTokenSelectorContainer: {
        marginLeft: theme.spacing(1),
        display: "flex",
        flexDirection: "column",
        width: "50%",
    },
    balanceContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(0.5),
        fontSize: "14px",
        minHeight: theme.spacing(3.8),
    },
    maxButton: {
        marginLeft: theme.spacing(2),
        color: theme.palette.primary.main,
        fontWeight: 700,
        fontSize: "12px",
        textTransform: "none",
        maxWidth: "min-content",
        minWidth: "min-content",
    },
    tokenButton: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        marginBottom: theme.spacing(1),
    },
    infoButton: {
        marginLeft: "5px",
        padding: 0,
        fontSize: "14px",
    },
}); });
function SwapCard(_a) {
    var containerStyle = _a.containerStyle, contentStyle = _a.contentStyle, swapTokenContainerStyle = _a.swapTokenContainerStyle, swapButtonStyle = _a.swapButtonStyle, connectWalletCallback = _a.connectWalletCallback;
    var styles = useStyles();
    return ((0, jsx_runtime_1.jsxs)(core_1.Card, __assign({ className: styles.card, style: containerStyle }, { children: [(0, jsx_runtime_1.jsx)(SwapHeader, {}, void 0), (0, jsx_runtime_1.jsxs)("div", __assign({ style: contentStyle }, { children: [(0, jsx_runtime_1.jsx)(SwapFromForm, { style: swapTokenContainerStyle }, void 0), (0, jsx_runtime_1.jsx)(ArrowButton, { style: swapTokenContainerStyle }, void 0), (0, jsx_runtime_1.jsx)(SwapToForm, { style: swapTokenContainerStyle }, void 0), (0, jsx_runtime_1.jsx)(Info_1.InfoLabel, {}, void 0), (0, jsx_runtime_1.jsx)(SwapButton, { swapButtonStyle: swapButtonStyle, connectWalletCallback: connectWalletCallback }, void 0)] }), void 0)] }), void 0));
}
exports.default = SwapCard;
function SwapHeader() {
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: {
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "16px",
        } }, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, __assign({ style: {
                    fontSize: 18,
                    fontWeight: 700,
                } }, { children: "SWAP" }), void 0), (0, jsx_runtime_1.jsx)(Info_1.InfoButton, {}, void 0)] }), void 0));
}
exports.SwapHeader = SwapHeader;
function ArrowButton(_a) {
    var style = _a.style;
    var styles = useStyles();
    var theme = (0, core_1.useTheme)();
    var swapToFromMints = (0, Swap_1.useSwapContext)().swapToFromMints;
    return ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ my: -1, position: "relative" }, { children: (0, jsx_runtime_1.jsx)(icons_1.ImportExportRounded, { className: styles.swapToFromButton, fontSize: "large", style: style, htmlColor: theme.palette.primary.main, onClick: swapToFromMints }, void 0) }), void 0));
}
exports.ArrowButton = ArrowButton;
function SwapFromForm(_a) {
    var style = _a.style;
    var _b = (0, Swap_1.useSwapContext)(), fromMint = _b.fromMint, setFromMint = _b.setFromMint, fromAmount = _b.fromAmount, setFromAmount = _b.setFromAmount;
    return ((0, jsx_runtime_1.jsx)(SwapTokenForm, { from: true, style: style, mint: fromMint, setMint: setFromMint, amount: fromAmount, setAmount: setFromAmount }, void 0));
}
function SwapToForm(_a) {
    var style = _a.style;
    var _b = (0, Swap_1.useSwapContext)(), toMint = _b.toMint, setToMint = _b.setToMint, toAmount = _b.toAmount, setToAmount = _b.setToAmount;
    return ((0, jsx_runtime_1.jsx)(SwapTokenForm, { from: false, style: style, mint: toMint, setMint: setToMint, amount: toAmount, setAmount: setToAmount }, void 0));
}
function SwapTokenForm(_a) {
    var from = _a.from, style = _a.style, mint = _a.mint, setMint = _a.setMint, amount = _a.amount, setAmount = _a.setAmount;
    var styles = useStyles();
    var _b = (0, react_1.useState)(false), showTokenDialog = _b[0], setShowTokenDialog = _b[1];
    var tokenAccount = (0, Token_1.useOwnedTokenAccount)(mint);
    var tokenInfo = (0, TokenList_1.useTokenInfo)(mint);
    var mintDecimals = tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.decimals;
    var balance = tokenAccount && mintDecimals && tokenAccount.tokenAmount;
    var formattedAmount = mintDecimals && amount
        ? amount.toLocaleString("fullwide", {
            maximumFractionDigits: mintDecimals,
            useGrouping: false,
        })
        : amount;
    var tokenDialog = (0, react_1.useMemo)(function () {
        return ((0, jsx_runtime_1.jsx)(TokenDialog_1.default, { setMint: setMint, open: showTokenDialog, onClose: function () { return setShowTokenDialog(false); } }, void 0));
    }, [showTokenDialog]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.swapTokenFormContainer, style: style }, { children: [(0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ display: "flex", justifyContent: "space-between" }, { children: [(0, jsx_runtime_1.jsx)(core_1.Box, __assign({ className: styles.swapTokenSelectorContainer }, { children: (0, jsx_runtime_1.jsx)(TokenButton, { mint: mint, onClick: function () { return setShowTokenDialog(true); } }, void 0) }), void 0), (0, jsx_runtime_1.jsx)(core_1.TextField, { type: "number", value: formattedAmount, onChange: function (e) { return setAmount(parseFloat(e.target.value)); }, InputProps: {
                            disableUnderline: true,
                            classes: {
                                root: styles.amountInput,
                                input: styles.input,
                            },
                        }, inputProps: {
                            min: 0,
                        } }, void 0)] }), void 0), (0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ className: styles.balanceContainer }, { children: [tokenAccount && mintDecimals ? ((0, jsx_runtime_1.jsxs)(core_1.Box, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, __assign({ variant: "caption" }, { children: (0, jsx_runtime_1.jsx)("small", { children: "Balance:\u00A0" }, void 0) }), void 0), balance === null || balance === void 0 ? void 0 : balance.toFixed(mintDecimals)] }, void 0)) : ("-"), !!balance && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(core_1.Button, __assign({ variant: "text", size: "small", className: styles.maxButton, onClick: function () { return setAmount(balance / 2); } }, { children: "Half" }), void 0), (0, jsx_runtime_1.jsx)(core_1.Button, __assign({ variant: "text", size: "small", className: styles.maxButton, onClick: function () { return setAmount(balance); } }, { children: "Max" }), void 0)] }, void 0))] }), void 0), tokenDialog] }), void 0));
}
exports.SwapTokenForm = SwapTokenForm;
function TokenButton(_a) {
    var mint = _a.mint, onClick = _a.onClick;
    var styles = useStyles();
    var theme = (0, core_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ onClick: onClick, className: styles.tokenButton }, { children: [(0, jsx_runtime_1.jsx)(TokenIcon, { mint: mint, style: { width: theme.spacing(4), height: theme.spacing(4) } }, void 0), (0, jsx_runtime_1.jsx)(TokenName, { mint: mint, style: { fontSize: 14, fontWeight: 700 } }, void 0), (0, jsx_runtime_1.jsx)(icons_1.ExpandMore, {}, void 0)] }), void 0));
}
function TokenIcon(_a) {
    var mint = _a.mint, style = _a.style;
    var tokenInfo = (0, TokenList_1.useTokenInfo)(mint);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ style: {
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
        } }, { children: (0, jsx_runtime_1.jsx)(core_1.Avatar, { alt: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.name, style: style, src: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.logoURI }, void 0) }), void 0));
}
exports.TokenIcon = TokenIcon;
function TokenName(_a) {
    var mint = _a.mint, style = _a.style;
    var theme = (0, core_1.useTheme)();
    var tokenInfo = (0, TokenList_1.useTokenInfo)(mint);
    return ((0, jsx_runtime_1.jsx)(core_1.Typography, __assign({ style: __assign({ marginLeft: theme.spacing(2), marginRight: theme.spacing(1) }, style) }, { children: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.symbol }), void 0));
}
function SwapButton(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f;
    var swapButtonStyle = _a.swapButtonStyle, connectWalletCallback = _a.connectWalletCallback;
    var styles = useStyles();
    var _g = (0, Swap_1.useSwapContext)(), fromMint = _g.fromMint, toMint = _g.toMint, fromAmount = _g.fromAmount, slippage = _g.slippage, isClosingNewAccounts = _g.isClosingNewAccounts, isStrict = _g.isStrict;
    var _h = (0, Dex_1.useDexContext)(), swapClient = _h.swapClient, addOpenOrderAccount = _h.addOpenOrderAccount;
    var userTokens = (0, Token_1.useTokenContext)().userTokens;
    var fromTokenInfo = (0, TokenList_1.useTokenInfo)(fromMint);
    var toTokenInfo = (0, TokenList_1.useTokenInfo)(toMint);
    var route = (0, Dex_1.useDexContext)().route;
    var fromMarket = (0, Dex_1.useMarket)((_b = route === null || route === void 0 ? void 0 : route.markets) === null || _b === void 0 ? void 0 : _b[0]);
    // Second market in case of multi-market swap
    var toMarket = (0, Dex_1.useMarket)((_c = route === null || route === void 0 ? void 0 : route.markets) === null || _c === void 0 ? void 0 : _c[1]);
    var toWallet = (0, Token_1.useOwnedTokenAccount)(toMint);
    var fromWallet = (0, Token_1.useOwnedTokenAccount)(fromMint);
    // Intermediary token for multi-market swaps, eg. USDC in a SRM -> BTC swap
    var quoteMint = fromMarket && fromMarket.quoteMintAddress;
    var quoteTokenInfo = (0, TokenList_1.useTokenInfo)(quoteMint);
    var quoteWallet = (0, Token_1.useOwnedTokenAccount)(quoteMint);
    var canCreateAccounts = (0, Swap_1.useCanCreateAccounts)();
    var canWrapOrUnwrap = (0, Swap_1.useCanWrapOrUnwrap)();
    var canSwap = (0, Swap_1.useCanSwap)();
    var referral = (0, Swap_1.useReferral)(fromMarket);
    var fair = (0, Swap_1.useSwapFair)();
    var minSwapAmount = (0, Swap_1.useMinSwapAmount)(fromMarket, toMarket);
    var _j = (0, Swap_1.useIsWrapSol)(fromMint, toMint), isWrapSol = _j.isWrapSol, isUnwrapSol = _j.isUnwrapSol;
    var isUnwrapSollet = (0, Swap_1.useIsUnwrapSollet)(fromMint, toMint);
    var fromOo = (0, Dex_1.useOpenOrderAccounts)((_d = route === null || route === void 0 ? void 0 : route.markets) === null || _d === void 0 ? void 0 : _d[0]);
    var toOo = (0, Dex_1.useOpenOrderAccounts)((_e = route === null || route === void 0 ? void 0 : route.markets) === null || _e === void 0 ? void 0 : _e[1]);
    var disconnected = !swapClient.program.provider.wallet.publicKey;
    var insufficientBalance = fromAmount == 0 || fromAmount > ((_f = fromWallet === null || fromWallet === void 0 ? void 0 : fromWallet.tokenAmount) !== null && _f !== void 0 ? _f : 0);
    var needsCreateAccounts = !toWallet || (!isUnwrapSollet && (!fromOo || (toMarket && !toOo)));
    var fromTokenDecimals = fromTokenInfo === null || fromTokenInfo === void 0 ? void 0 : fromTokenInfo.decimals;
    var toTokenDecimals = toTokenInfo === null || toTokenInfo === void 0 ? void 0 : toTokenInfo.decimals;
    var quoteTokenDecimals = quoteTokenInfo === null || quoteTokenInfo === void 0 ? void 0 : quoteTokenInfo.decimals;
    // Click handlers.
    /**
     * Find if OpenOrders or associated token accounts are required
     * for the swap, then send a create transaction
     */
    var sendCreateAccountsTransaction = function () { return __awaiter(_this, void 0, void 0, function () {
        // No point of initializing from wallet, as user won't have tokens there
        // Helper functions for OpenOrders
        /**
         * Add instructions to init and create an OpenOrders account
         * @param openOrdersKeypair
         * @param market
         * @param tx
         */
        function getInitOpenOrdersIx(openOrdersKeypair, market, tx) {
            return __awaiter(this, void 0, void 0, function () {
                var createOoIx, initAcIx;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, serum_1.OpenOrders.makeCreateAccountTransaction(swapClient.program.provider.connection, market, swapClient.program.provider.wallet.publicKey, openOrdersKeypair.publicKey, pubkeys_1.DEX_PID)];
                        case 1:
                            createOoIx = _a.sent();
                            initAcIx = swapClient.program.instruction.initAccount({
                                accounts: {
                                    openOrders: openOrdersKeypair.publicKey,
                                    authority: swapClient.program.provider.wallet.publicKey,
                                    market: market,
                                    dexProgram: pubkeys_1.DEX_PID,
                                    rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                                },
                            });
                            tx.add(createOoIx);
                            tx.add(initAcIx);
                            return [2 /*return*/];
                    }
                });
            });
        }
        /**
         * Save data of newly created OpenOrders account in cache
         * TODO: generate object client side to save a network call
         * @param openOrdersAddress
         */
        function saveOpenOrders(openOrdersAddress, market) {
            return __awaiter(this, void 0, void 0, function () {
                var createdOo;
                return __generator(this, function (_a) {
                    createdOo = new serum_1.OpenOrders(openOrdersAddress, undefined, pubkeys_1.DEX_PID);
                    addOpenOrderAccount(market, createdOo);
                    return [2 /*return*/];
                });
            });
        }
        var tx, signers, toAssociatedPubkey, quoteAssociatedPubkey, _a, tokenAddress, createTokenAddrIx, _b, tokenAddress, createTokenAddrIx, ooFrom, ooTo, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    // Check if null or undefined (== coercion), but not 0
                    if (fromTokenDecimals == null || toTokenDecimals == null) {
                        throw new Error("Unable to calculate mint decimals");
                    }
                    if (!quoteMint || quoteTokenDecimals == null) {
                        throw new Error("Quote mint not found");
                    }
                    tx = new web3_js_1.Transaction();
                    signers = [];
                    if (!!toWallet) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, tokens_1.getTokenAddrressAndCreateIx)(toMint, swapClient.program.provider.wallet.publicKey)];
                case 1:
                    _a = _c.sent(), tokenAddress = _a.tokenAddress, createTokenAddrIx = _a.createTokenAddrIx;
                    toAssociatedPubkey = tokenAddress;
                    tx.add(createTokenAddrIx);
                    _c.label = 2;
                case 2:
                    if (!(!quoteWallet && !quoteMint.equals(toMint))) return [3 /*break*/, 4];
                    return [4 /*yield*/, (0, tokens_1.getTokenAddrressAndCreateIx)(quoteMint, swapClient.program.provider.wallet.publicKey)];
                case 3:
                    _b = _c.sent(), tokenAddress = _b.tokenAddress, createTokenAddrIx = _b.createTokenAddrIx;
                    quoteAssociatedPubkey = tokenAddress;
                    tx.add(createTokenAddrIx);
                    _c.label = 4;
                case 4:
                    if (!(fromMarket && (!fromOo || (fromOo === null || fromOo === void 0 ? void 0 : fromOo.length) === 0))) return [3 /*break*/, 6];
                    ooFrom = web3_js_1.Keypair.generate();
                    return [4 /*yield*/, getInitOpenOrdersIx(ooFrom, fromMarket.address, tx)];
                case 5:
                    _c.sent();
                    signers.push(ooFrom);
                    _c.label = 6;
                case 6:
                    if (!(toMarket && (!serum_1.OpenOrders || (fromOo === null || fromOo === void 0 ? void 0 : fromOo.length) === 0))) return [3 /*break*/, 8];
                    ooTo = web3_js_1.Keypair.generate();
                    return [4 /*yield*/, getInitOpenOrdersIx(ooTo, toMarket.address, tx)];
                case 7:
                    _c.sent();
                    signers.push(ooTo);
                    _c.label = 8;
                case 8:
                    _c.trys.push([8, 14, , 15]);
                    // Send transaction to create accounts
                    return [4 /*yield*/, swapClient.program.provider.send(tx, signers)];
                case 9:
                    // Send transaction to create accounts
                    _c.sent();
                    if (!(ooFrom && fromMarket)) return [3 /*break*/, 11];
                    return [4 /*yield*/, saveOpenOrders(ooFrom.publicKey, fromMarket.address)];
                case 10:
                    _c.sent();
                    _c.label = 11;
                case 11:
                    if (!(ooTo && toMarket)) return [3 /*break*/, 13];
                    return [4 /*yield*/, saveOpenOrders(ooTo.publicKey, toMarket.address)];
                case 12:
                    _c.sent();
                    _c.label = 13;
                case 13: return [3 /*break*/, 15];
                case 14:
                    error_1 = _c.sent();
                    return [3 /*break*/, 15];
                case 15: return [2 /*return*/];
            }
        });
    }); };
    var sendWrapSolTransaction = function () { return __awaiter(_this, void 0, void 0, function () {
        var amount, wrappedSolAccount, wrappedSolPubkey, _a, _b, tx, signers, _c, unwrapTx, unwrapSigners;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!fromTokenDecimals || !toTokenDecimals) {
                        throw new Error("Unable to calculate mint decimals");
                    }
                    if (!quoteMint || !quoteTokenDecimals) {
                        throw new Error("Quote mint not found");
                    }
                    amount = new spl_token_1.u64(fromAmount * Math.pow(10, fromTokenDecimals));
                    wrappedSolAccount = toWallet ? web3_js_1.Keypair.generate() : undefined;
                    if (!wrappedSolAccount) return [3 /*break*/, 1];
                    _a = wrappedSolAccount.publicKey;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, spl_token_1.Token.getAssociatedTokenAddress(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, fromMint, swapClient.program.provider.wallet.publicKey)];
                case 2:
                    _a = _d.sent();
                    _d.label = 3;
                case 3:
                    wrappedSolPubkey = _a;
                    return [4 /*yield*/, wrapSol(swapClient.program.provider, fromMint, amount, wrappedSolAccount)];
                case 4:
                    _b = _d.sent(), tx = _b.tx, signers = _b.signers;
                    // Close the newly created account, if needed.
                    if (toWallet) {
                        tx.add(spl_token_1.Token.createTransferInstruction(spl_token_1.TOKEN_PROGRAM_ID, wrappedSolPubkey, new web3_js_1.PublicKey(toWallet.tokenAccount), swapClient.program.provider.wallet.publicKey, [], amount));
                        _c = unwrapSol(swapClient.program.provider, wrappedSolPubkey), unwrapTx = _c.tx, unwrapSigners = _c.signers;
                        tx.add(unwrapTx);
                        signers.push.apply(signers, unwrapSigners);
                    }
                    return [4 /*yield*/, swapClient.program.provider.send(tx, signers)];
                case 5:
                    _d.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var sendUnwrapSolTransaction = function () { return __awaiter(_this, void 0, void 0, function () {
        var amount, wrappedSolAccount, _a, tx, signers, _b, unwrapTx, unwrapSigners;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!fromTokenDecimals || !toTokenDecimals) {
                        throw new Error("Unable to calculate mint decimals");
                    }
                    if (!quoteMint || !quoteTokenDecimals) {
                        throw new Error("Quote mint not found");
                    }
                    amount = new spl_token_1.u64(fromAmount * Math.pow(10, fromTokenDecimals));
                    wrappedSolAccount = web3_js_1.Keypair.generate();
                    return [4 /*yield*/, wrapSol(swapClient.program.provider, fromMint, amount, wrappedSolAccount)];
                case 1:
                    _a = _c.sent(), tx = _a.tx, signers = _a.signers;
                    tx.add(spl_token_1.Token.createTransferInstruction(spl_token_1.TOKEN_PROGRAM_ID, new web3_js_1.PublicKey(fromWallet.tokenAccount), wrappedSolAccount.publicKey, swapClient.program.provider.wallet.publicKey, [], amount));
                    _b = unwrapSol(swapClient.program.provider, wrappedSolAccount.publicKey), unwrapTx = _b.tx, unwrapSigners = _b.signers;
                    tx.add(unwrapTx);
                    signers.push.apply(signers, unwrapSigners);
                    return [4 /*yield*/, swapClient.program.provider.send(tx, signers)];
                case 2:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var sendUnwrapSolletTransaction = function () { return __awaiter(_this, void 0, void 0, function () {
        var solletReqBody, solletRes, _a, bridgeAddr, maxSize, tx, amount;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!fromTokenDecimals || !toTokenDecimals) {
                        throw new Error("Unable to calculate mint decimals");
                    }
                    solletReqBody = {
                        address: toWallet.tokenAccount,
                        blockchain: "sol",
                        coin: toMint.toString(),
                        size: 1,
                    };
                    if (fromMint.equals(pubkeys_1.SOLLET_USDT_MINT)) {
                        solletReqBody.wusdtToUsdt = true;
                    }
                    else {
                        solletReqBody.wusdcToUsdc = true;
                    }
                    return [4 /*yield*/, fetch("https://swap.sollet.io/api/swap_to", {
                            method: "POST",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(solletReqBody),
                        })];
                case 1:
                    solletRes = _b.sent();
                    return [4 /*yield*/, solletRes.json()];
                case 2:
                    _a = (_b.sent())
                        .result, bridgeAddr = _a.address, maxSize = _a.maxSize;
                    tx = new web3_js_1.Transaction();
                    amount = new spl_token_1.u64(fromAmount * Math.pow(10, fromTokenDecimals));
                    tx.add(spl_token_1.Token.createTransferInstruction(spl_token_1.TOKEN_PROGRAM_ID, new web3_js_1.PublicKey(fromWallet.tokenAccount), new web3_js_1.PublicKey(bridgeAddr), swapClient.program.provider.wallet.publicKey, [], amount));
                    tx.add(new web3_js_1.TransactionInstruction({
                        keys: [],
                        data: Buffer.from(toWallet.tokenAccount, "utf-8"),
                        programId: pubkeys_1.MEMO_PROGRAM_ID,
                    }));
                    return [4 /*yield*/, swapClient.program.provider.send(tx)];
                case 3:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var sendSwapTransaction = function () { return __awaiter(_this, void 0, void 0, function () {
        var amount, isSol, wrappedSolAccount, txs, _a, wrapTx, wrapSigners, _b, unwrapTx, unwrapSigners, tx;
        var _c, _d;
        var _this = this;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!fromTokenDecimals || !toTokenDecimals) {
                        throw new Error("Unable to calculate mint decimals");
                    }
                    if (!fair) {
                        throw new Error("Invalid fair");
                    }
                    if (!quoteMint || !quoteTokenDecimals) {
                        throw new Error("Quote mint not found");
                    }
                    amount = new anchor_1.BN(fromAmount * Math.pow(10, fromTokenDecimals));
                    isSol = fromMint.equals(pubkeys_1.SOL_MINT) || toMint.equals(pubkeys_1.SOL_MINT);
                    wrappedSolAccount = isSol ? web3_js_1.Keypair.generate() : undefined;
                    return [4 /*yield*/, (function () { return __awaiter(_this, void 0, void 0, function () {
                            var minExchangeRate, fromWalletAddr, toWalletAddr;
                            var _a, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        if (!fromMarket) {
                                            throw new Error("Market undefined");
                                        }
                                        minExchangeRate = {
                                            rate: new anchor_1.BN((Math.pow(10, toTokenDecimals) * Dex_1.FEE_MULTIPLIER) / fair)
                                                .muln(100 - slippage)
                                                .divn(100),
                                            fromDecimals: fromTokenDecimals,
                                            quoteDecimals: quoteTokenDecimals,
                                            strict: isStrict,
                                        };
                                        fromWalletAddr = fromMint.equals(pubkeys_1.SOL_MINT)
                                            ? wrappedSolAccount.publicKey
                                            : fromWallet
                                                ? new web3_js_1.PublicKey(fromWallet.tokenAccount)
                                                : undefined;
                                        toWalletAddr = toMint.equals(pubkeys_1.SOL_MINT)
                                            ? wrappedSolAccount.publicKey
                                            : toWallet
                                                ? new web3_js_1.PublicKey(toWallet.tokenAccount)
                                                : undefined;
                                        return [4 /*yield*/, swapClient.swapTxs({
                                                fromMint: fromMint,
                                                toMint: toMint,
                                                quoteMint: quoteMint,
                                                amount: amount,
                                                minExchangeRate: minExchangeRate,
                                                referral: referral,
                                                fromMarket: fromMarket,
                                                toMarket: toMarket,
                                                fromOpenOrders: (_a = fromOo === null || fromOo === void 0 ? void 0 : fromOo[0]) === null || _a === void 0 ? void 0 : _a.address,
                                                toOpenOrders: (_b = toOo === null || toOo === void 0 ? void 0 : toOo[0]) === null || _b === void 0 ? void 0 : _b.address,
                                                fromWallet: fromWalletAddr,
                                                toWallet: toWalletAddr,
                                                quoteWallet: quoteWallet
                                                    ? new web3_js_1.PublicKey(quoteWallet.tokenAccount)
                                                    : undefined,
                                                // Auto close newly created open orders accounts.
                                                close: isClosingNewAccounts,
                                            })];
                                    case 1: return [2 /*return*/, _c.sent()];
                                }
                            });
                        }); })()];
                case 1:
                    txs = _e.sent();
                    if (!isSol) return [3 /*break*/, 3];
                    if (txs.length > 1) {
                        throw new Error("SOL must be swapped in a single transaction");
                    }
                    return [4 /*yield*/, wrapSol(swapClient.program.provider, fromMint, amount, wrappedSolAccount)];
                case 2:
                    _a = _e.sent(), wrapTx = _a.tx, wrapSigners = _a.signers;
                    _b = unwrapSol(swapClient.program.provider, wrappedSolAccount.publicKey), unwrapTx = _b.tx, unwrapSigners = _b.signers;
                    tx = new web3_js_1.Transaction();
                    tx.add(wrapTx);
                    tx.add(txs[0].tx);
                    tx.add(unwrapTx);
                    txs[0].tx = tx;
                    (_c = txs[0].signers).push.apply(_c, wrapSigners);
                    (_d = txs[0].signers).push.apply(_d, unwrapSigners);
                    _e.label = 3;
                case 3: return [4 /*yield*/, swapClient.program.provider.sendAll(txs)];
                case 4:
                    _e.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    if (disconnected) {
        return ((0, jsx_runtime_1.jsx)(core_1.Button, __assign({ variant: "contained", className: styles.swapButton, onClick: connectWalletCallback, disabled: !connectWalletCallback, style: swapButtonStyle, color: "secondary" }, { children: !!connectWalletCallback ? "Connect Wallet" : "Disconnected" }), void 0));
    }
    if (!userTokens || !fromOo || (toMarket && !toOo)) {
        return ((0, jsx_runtime_1.jsx)(core_1.Button, __assign({ variant: "contained", className: styles.swapButton, onClick: sendSwapTransaction, disabled: true, style: swapButtonStyle, color: "secondary" }, { children: "Loading..." }), void 0));
    }
    return !fromWallet || insufficientBalance ? ((0, jsx_runtime_1.jsx)(core_1.Button, __assign({ variant: "contained", className: styles.swapButton, color: "secondary", style: swapButtonStyle, disabled: true }, { children: "Insufficient balance" }), void 0)) : needsCreateAccounts ? ((0, jsx_runtime_1.jsx)(core_1.Button, __assign({ variant: "contained", className: styles.swapButton, onClick: sendCreateAccountsTransaction, disabled: !canCreateAccounts, color: "secondary", style: swapButtonStyle }, { children: "Create Accounts" }), void 0)) : isWrapSol ? ((0, jsx_runtime_1.jsx)(core_1.Button, __assign({ variant: "contained", className: styles.swapButton, color: "secondary", style: swapButtonStyle, onClick: sendWrapSolTransaction, disabled: !canWrapOrUnwrap }, { children: "Wrap SOL" }), void 0)) : isUnwrapSol ? ((0, jsx_runtime_1.jsx)(core_1.Button, __assign({ variant: "contained", className: styles.swapButton, onClick: sendUnwrapSolTransaction, color: "secondary", style: swapButtonStyle, disabled: !canWrapOrUnwrap }, { children: "Unwrap SOL" }), void 0)) : isUnwrapSollet ? ((0, jsx_runtime_1.jsx)(core_1.Button, __assign({ variant: "contained", className: styles.swapButton, onClick: sendUnwrapSolletTransaction, disabled: fromAmount <= 0, color: "secondary", style: swapButtonStyle }, { children: "Unwrap" }), void 0)) : minSwapAmount ? ((0, jsx_runtime_1.jsxs)(core_1.Button, __assign({ variant: "contained", className: styles.swapButton, onClick: sendSwapTransaction, disabled: true, color: "secondary", style: swapButtonStyle }, { children: ["Min ", minSwapAmount, " Required"] }), void 0)) : ((0, jsx_runtime_1.jsx)(core_1.Button, __assign({ variant: "contained", className: styles.swapButton, onClick: sendSwapTransaction, disabled: !canSwap, color: "secondary", style: swapButtonStyle }, { children: "Swap" }), void 0));
}
exports.SwapButton = SwapButton;
// If wrappedSolAccount is undefined, then creates the account with
// an associated token account.
function wrapSol(provider, fromMint, amount, wrappedSolAccount) {
    return __awaiter(this, void 0, void 0, function () {
        var tx, signers, wrappedSolPubkey, _a, _b, _c, _d;
        var _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    tx = new web3_js_1.Transaction();
                    signers = wrappedSolAccount ? [wrappedSolAccount] : [];
                    if (!(wrappedSolAccount === undefined)) return [3 /*break*/, 2];
                    return [4 /*yield*/, spl_token_1.Token.getAssociatedTokenAddress(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, fromMint, provider.wallet.publicKey)];
                case 1:
                    wrappedSolPubkey = _f.sent();
                    tx.add(spl_token_1.Token.createAssociatedTokenAccountInstruction(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, fromMint, wrappedSolPubkey, provider.wallet.publicKey, provider.wallet.publicKey));
                    return [3 /*break*/, 4];
                case 2:
                    wrappedSolPubkey = wrappedSolAccount.publicKey;
                    _b = (_a = tx).add;
                    _d = (_c = web3_js_1.SystemProgram).createAccount;
                    _e = {
                        fromPubkey: provider.wallet.publicKey,
                        newAccountPubkey: wrappedSolPubkey
                    };
                    return [4 /*yield*/, spl_token_1.Token.getMinBalanceRentForExemptAccount(provider.connection)];
                case 3:
                    _b.apply(_a, [_d.apply(_c, [(_e.lamports = _f.sent(),
                                _e.space = 165,
                                _e.programId = spl_token_1.TOKEN_PROGRAM_ID,
                                _e)])]);
                    _f.label = 4;
                case 4:
                    // Transfer lamports. These will be converted to an SPL balance by the
                    // token program.
                    if (fromMint.equals(pubkeys_1.SOL_MINT)) {
                        tx.add(web3_js_1.SystemProgram.transfer({
                            fromPubkey: provider.wallet.publicKey,
                            toPubkey: wrappedSolPubkey,
                            lamports: amount.toNumber(),
                        }));
                    }
                    // Initialize the account.
                    tx.add(spl_token_1.Token.createInitAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, pubkeys_1.WRAPPED_SOL_MINT, wrappedSolPubkey, provider.wallet.publicKey));
                    return [2 /*return*/, { tx: tx, signers: signers }];
            }
        });
    });
}
function unwrapSol(provider, wrappedSol) {
    var tx = new web3_js_1.Transaction();
    tx.add(spl_token_1.Token.createCloseAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, wrappedSol, provider.wallet.publicKey, provider.wallet.publicKey, []));
    return { tx: tx, signers: [] };
}
